'use client';

import { Box, InlineNotification } from '@packages/shared';
import { useIntl } from 'react-intl';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { errorFallbackMessages } from './messages';

export type ErrorFallbackProps = {
  onClose: () => void;
};

export const ErrorFallback = ({ onClose }: ErrorFallbackProps) => {
  const { formatMessage } = useIntl();
  return (
    <Dialog isOpen onClose={onClose}>
      <DialogContent>
        <Box p={1} maxWidth="54.438rem" m="auto">
          <InlineNotification severity="warning">
            {formatMessage(errorFallbackMessages.notification)}
          </InlineNotification>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
